/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGitMerge = createReactComponent("git-merge", "IconGitMerge", [
  ["path", { d: "M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-2" }],
  ["path", { d: "M7 8l0 8", key: "svg-3" }],
  ["path", { d: "M7 8a4 4 0 0 0 4 4h4", key: "svg-4" }]
]);

export { IconGitMerge as default };
//# sourceMappingURL=IconGitMerge.js.map
